module.exports = __webpack_public_path__ + "static/4pilares-570-c110162253b2e8ef77d126d497a1dd34.jpg";